import { dropdownEllipsisWidth } from "ds/components/DropdownMenu/constants";
import { Spacing } from "types/Spacing";

export const COLUMN_ORDER = `minmax(200px, 5fr) minmax(90px, 2fr) minmax(90px, 1fr) ${dropdownEllipsisWidth}`;
export const COLUMN_GAP: Spacing = "large";
export const LOGIN_POLICY_INACTIVE_INFO_STORAGE_KEY = "loginPolicyInactiveInfo";
